import { useTranslation } from 'react-i18next';
import { ListSearchInput } from '@/components/admin/shared/ListSearchInput';
import { Button } from '@/components/ui/button';
import { DatePicker } from '@/components/ui/datePicker';
import { Label } from '@/components/ui/label';
import type { ActivityLogFilterState } from '@/hooks/useActivityLogFilters';
import { ActivityCategoryFilter } from './ActivityCategoryFilter';

interface ActivityLogFilterBarProps {
  filters: ActivityLogFilterState;
  idPrefix: string;
}

export function ActivityLogFilterBar({ filters, idPrefix }: ActivityLogFilterBarProps) {
  const { t } = useTranslation('activity');
  const fromId = idPrefix + '-from';
  const untilId = idPrefix + '-until';
  const hasDates = filters.fromDate.length > 0 || filters.untilDate.length > 0;

  return (
    <div className="flex flex-col gap-3 mb-5">
      <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_auto] gap-3 items-start">
        <ListSearchInput
          value={filters.searchInput}
          onChange={filters.setSearchInput}
          placeholder={t('searchPlaceholder')}
        />
        <ActivityCategoryFilter value={filters.category} onChange={filters.setCategory} />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-[minmax(0,220px)_minmax(0,220px)_auto] gap-3 items-end">
        <div className="space-y-1.5">
          <Label htmlFor={fromId}>{t('dates.from')}</Label>
          <DatePicker id={fromId} value={filters.fromDate} onChange={filters.setFromDate} />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor={untilId}>{t('dates.until')}</Label>
          <DatePicker id={untilId} value={filters.untilDate} onChange={filters.setUntilDate} />
        </div>
        {hasDates === true ? (
          <Button
            variant="ghost"
            size="small"
            className="justify-self-start"
            onClick={filters.clearDates}
          >
            {t('dates.clear')}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
